import { render } from "./NcrmPrivacyBulkPreviewAction.vue?vue&type=template&id=79cfad08&scoped=true"
import script from "./NcrmPrivacyBulkPreviewAction.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyBulkPreviewAction.vue?vue&type=script&lang=js"

import "./NcrmPrivacyBulkPreviewAction.vue?vue&type=style&index=0&id=79cfad08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cfad08"]])

export default __exports__